/**
 * nucleus-monitoring-service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RemoteLogSchedule { 
    id?: number;
    serviceName?: string;
    instanceId?: string;
    startTime?: string;
    endTime?: string;
    timezone?: string;
    recurrence?: RemoteLogSchedule.RecurrenceEnum;
    nextRunDate?: string;
    startDate?: string;
    endDate?: string;
    levels?: string;
    captureLogs?: boolean;
    captureGc?: boolean;
    captureThreads?: boolean;
    threadsIntervalMs?: number;
    persistent?: boolean;
    active?: boolean;
    createdBy?: string;
    notes?: string;
    createdAt?: string;
    updatedAt?: string;
}
export namespace RemoteLogSchedule {
    export const RecurrenceEnum = {
        Once: 'ONCE',
        Daily: 'DAILY',
        Weekdays: 'WEEKDAYS',
        Weekends: 'WEEKENDS'
    } as const;
    export type RecurrenceEnum = typeof RecurrenceEnum[keyof typeof RecurrenceEnum];
}


